import { Component, input, output } from '@angular/core';

import { AddMemberAction, AddMemberFlowChoiceCardI } from '@core/tellent-types';
import { HeadingComponent, IconComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'tla-add-member-flow-choice-card',
  imports: [IconComponent, HeadingComponent],
  templateUrl: './add-member-flow-choice-card.component.html',
  styleUrl: './add-member-flow-choice-card.component.less',
})
export class AddMemberFlowChoiceCardComponent {
  public card = input.required<AddMemberFlowChoiceCardI>();

  public cardClick = output<AddMemberAction>();
}
